const OncologiaIconMini = ({ color }) => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 32 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17.5272" cy="10.3252" r="9.95996" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0379 36.9986C35.0379 30.3221 30.2667 24.76 23.9479 23.5358V29.5657C25.9656 29.9642 27.4872 31.7434 27.4872 33.878V34.3065C27.4872 35.6386 26.4073 36.7185 25.0751 36.7185H24.1175V34.7185H25.0751C25.3027 34.7185 25.4872 34.5341 25.4872 34.3065V33.878C25.4872 32.5549 24.4146 31.4824 23.0915 31.4824C21.7684 31.4824 20.6959 32.5549 20.6959 33.878V34.3065C20.6959 34.5341 20.8803 34.7185 21.1079 34.7185H22.1175V36.7185H21.1079C19.7758 36.7185 18.6959 35.6386 18.6959 34.3065V33.878C18.6959 31.8459 20.0748 30.1359 21.9479 29.6326V23.2991C21.7413 23.2898 21.5334 23.2852 21.3245 23.2852H13.73C13.4254 23.2852 13.1232 23.2951 12.8235 23.3146V29.5993C14.5948 30.0134 15.9032 31.4704 15.9032 33.2042C15.9032 35.2602 14.0632 36.9269 11.7935 36.9269C9.5238 36.9269 7.68384 35.2602 7.68384 33.2042C7.68384 31.4509 9.02194 29.9806 10.8235 29.5857V23.5938C4.64584 24.9269 0.0165405 30.4221 0.0165405 36.9986C0.0165405 37.9453 0.784005 38.7128 1.73072 38.7128H33.3237C34.2704 38.7128 35.0379 37.9453 35.0379 36.9986ZM11.7935 34.9269C13.1493 34.9269 13.9032 33.9742 13.9032 33.2042C13.9032 32.4342 13.1493 31.4814 11.7935 31.4814C10.4377 31.4814 9.68384 32.4342 9.68384 33.2042C9.68384 33.9742 10.4377 34.9269 11.7935 34.9269Z"
          fill={color}
        />
      </svg>
    );
  };
  
  export default OncologiaIconMini;
  